import type { GuideImage } from "../components/Guide";
export const shots: Record<string, GuideImage> = {
	login: {
		file: "login",
		alt: "Вход: электронная почта, пароль и кнопка «Войти»",
		width: 440,
		height: 345,
		crop: [420, 190],
		marks: [
			{
				label: "Почта и пароль",
				text: "Нажмите внутри каждого поля и введите свои данные. Email — адрес электронной почты.",
				box: [40, 118, 360, 103],
			},
			{
				label: "Войти",
				text: "Нажмите один раз после заполнения обоих полей.",
				box: [40, 230, 360, 47],
			},
			{
				label: "Забыли пароль?",
				text: "Открывает восстановление доступа по электронной почте.",
				box: [40, 286, 360, 31],
			},
		],
	},
	schedule: {
		file: "schedule",
		alt: "График: период, бригады и цветные блоки работ",
		width: 1280,
		height: 490,
		marks: [
			{
				label: "Период",
				text: "Начальная и конечная даты определяют, какую часть графика вы видите.",
				box: [488, 16, 357, 75],
			},
			{
				label: "Бригады и работы",
				text: "Слева — бригады, сверху — дни. Цветная полоска показывает назначенную работу.",
				box: [267, 148, 880, 180],
			},
			{
				label: "В ожидании",
				text: "Здесь находятся работы, которые пока не назначены на дату и бригаду.",
				box: [859, 46, 190, 46],
			},
		],
	},
	block: {
		file: "create-block",
		alt: "Создание блока: дата, бригада и название работы",
		width: 472,
		height: 644,
		crop: [404, 38],
		marks: [
			{
				label: "Дата и бригада",
				text: "Укажите, когда начнётся работа и кто её выполнит.",
				box: [33, 124, 406, 162],
			},
			{
				label: "Объект и работа",
				text: "Выберите объект из списка, затем проверьте название работы и длительность.",
				box: [33, 299, 406, 254],
			},
			{
				label: "Создать",
				text: "Нажмите, когда проверите данные. «Отмена» закрывает окно без создания работы.",
				box: [241, 572, 104, 48],
			},
		],
	},
	objects: {
		file: "objects",
		alt: "Список объектов: поиск и добавление",
		width: 1280,
		height: 490,
		marks: [
			{
				label: "Поиск",
				text: "Начните вводить название — список обновляется по мере ввода.",
				box: [279, 44, 240, 48],
			},
			{
				label: "Добавить объект",
				text: "Открывает форму нового объекта.",
				box: [655, 44, 196, 48],
			},
			{
				label: "Строка объекта",
				text: "Нажмите на название нужного объекта, чтобы открыть его карточку.",
				box: [279, 175, 847, 94],
			},
		],
	},
	objectForm: {
		file: "create-object",
		alt: "Форма нового объекта: название и сохранение",
		width: 472,
		height: 703,
		crop: [404, 8],
		marks: [
			{
				label: "Название",
				text: "Обязательное поле. Например: «Офис — монтаж перегородок».",
				box: [32, 178, 408, 69],
			},
			{
				label: "Уточнения",
				text: "Менеджер, адрес и дата помогают отличить объект от похожих.",
				box: [32, 265, 408, 247],
			},
			{
				label: "Сохранить",
				text: "После сохранения откроется карточка созданного объекта.",
				box: [209, 630, 125, 49],
			},
		],
	},
	brigades: {
		file: "brigades",
		alt: "Настройки: вкладка «Бригады» и кнопка создания",
		width: 1280,
		height: 600,
		marks: [
			{
				label: "Настройки",
				text: "Бригады находятся внутри раздела «Настройки», а не в отдельном пункте меню.",
				box: [14, 289, 222, 46],
			},
			{
				label: "Бригады",
				text: "Выберите эту вкладку. Ниже видны активные бригады и архив.",
				box: [265, 120, 103, 49],
			},
			{
				label: "Создать бригаду",
				text: "Откройте форму, укажите название и оставьте бригаду активной.",
				box: [1085, 187, 151, 40],
			},
		],
	},
	warehouse: {
		file: "warehouse",
		alt: "Склад: вкладки и остатки материалов",
		width: 1280,
		height: 600,
		marks: [
			{
				label: "Материалы",
				text: "Здесь смотрят, сколько материала есть на складе.",
				box: [265, 251, 124, 49],
			},
			{
				label: "Остатки",
				text: "«На складе» — всё количество; «В резерве» — уже обещано объектам; «Доступно» — свободный остаток.",
				box: [639, 398, 180, 197],
			},
			{
				label: "Резервации",
				text: "Здесь материал закрепляют за объектом, затем оформляют выдачу.",
				box: [388, 251, 124, 49],
			},
		],
	},
	reports: {
		file: "reports",
		alt: "Общий отчёт: период и кнопка скачивания",
		width: 1280,
		height: 867,
		marks: [
			{
				label: "Вид отчёта",
				text: "Выберите «Общий отчёт», «По бригадам» или «Складская логистика».",
				box: [280, 90, 468, 47],
			},
			{
				label: "Период",
				text: "«С месяца» и «По месяц» задают начало и конец отчёта.",
				box: [280, 153, 970, 166],
			},
			{
				label: "Скачать",
				text: "Для общего отчёта нажмите «Скачать общий». Файл появится в загрузках браузера.",
				box: [973, 766, 159, 47],
			},
		],
	},
	settings: {
		file: "settings",
		alt: "Настройки таблицы: выходные, планирование по времени и изменение",
		width: 1280,
		height: 720,
		marks: [
			{
				label: "Настройки таблицы",
				text: "Выберите вкладку в разделе «Настройки».",
				box: [362, 121, 192, 48],
			},
			{
				label: "Учёт времени",
				text: "Эта настройка включает планирование по часам для организации.",
				box: [295, 548, 354, 67],
			},
			{
				label: "Изменить",
				text: "Сначала нажмите «Изменить», затем настройте нужные поля и сохраните.",
				box: [295, 630, 118, 49],
			},
		],
	},
	users: {
		file: "users",
		alt: "Пользователи: поиск сотрудника, роль и добавление",
		width: 1280,
		height: 600,
		marks: [
			{
				label: "Пользователи",
				text: "Раздел доступен сотрудникам, которым разрешено управлять пользователями.",
				box: [13, 446, 225, 48],
			},
			{
				label: "Добавить",
				text: "Открывает форму нового сотрудника.",
				box: [514, 127, 247, 48],
			},
			{
				label: "Роль",
				text: "Показывает назначенный набор доступа. Доступные действия зависят от выданных прав.",
				box: [873, 202, 163, 106],
			},
		],
	},
};
